import { Divider, Button, Breadcrumb, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import { ScanVisitor } from "./ScanProduct";
import { LanguageContext } from "../../../context/Language.contex";
import { useContext } from "react";

export const SearchDetailVisitor = () => {
  const { language } = useContext(LanguageContext);
  const navigate = useNavigate();
  return (
    <div
      className="wrapper"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #e3eaf5 0%, #f8fbff 100%)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="navbar" style={{ padding: "32px 0 0 0" }}>
        <Breadcrumb style={{ margin: "0 0 32px 32px", fontSize: 16 }}>
          <Breadcrumb.Item>
            <a
              onClick={() => navigate("/")}
              style={{ color: "#2C74B3", fontWeight: "bold" }}
            >
              Home
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item style={{ color: "#2C74B3", fontWeight: "bold" }}>
            {language[23]}
          </Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: "none",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className="login-area"
            style={{
              maxWidth: 420,
              width: "100%",
              background: "#fff",
              borderRadius: 16,
              boxShadow: "0 4px 24px rgba(44,116,179,0.10)",
              padding: 32,
              margin: "0 auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ScanVisitor />
          </div>
        </Layout>
      </div>
      <div
        className="footers"
        style={{
          marginTop: "auto",
          padding: "24px 0",
          textAlign: "center",
          color: "#888",
        }}
      >
        {/* <Footers /> */}
        <span style={{ fontSize: 14 }}>© 2025 Visitor Management System</span>
      </div>
    </div>
  );
};
